<template>
  <v-text-field
    v-model="hookParentChild"
    @click:append="() => (passwordHide = !passwordHide)"
    :type="passwordHide === true ? 'password' : 'text'"
    :append-icon="passwordHide === true ? mdiEye : mdiEyeOff"
    :rules="passwordRules"
    :label="$t('password')"
    :prepend-inner-icon="mdiLockOutline"
    name="password"
    placeholder=" "
    class="body-2"
    outlined
    required
  ></v-text-field>
</template>

<script>
import { mdiEye, mdiEyeOff, mdiLockOutline } from "@mdi/js";
import XRegExp from "xregexp";

export default {
  name: "EyePassword",
  data: vm => ({
    passwordHide: true,
    password: "",
    passwordRules: [
      v => !!v || vm.$t("field-requied"),
      v =>
        XRegExp(
          "^(?=.*\\p{Ll})(?=.*\\p{Lu})(?=.*[0-9])(?=.*[ -/:-@\\[-`{-~]).{6,64}$"
        ).test(v) || vm.$t("password-invalid")
    ],
    mdiEye: mdiEye,
    mdiEyeOff: mdiEyeOff,
    mdiLockOutline: mdiLockOutline
  }),
  computed: {
    hookParentChild: {
      get() {
        return this.password;
      },
      set(password) {
        this.password = password;
        this.$emit("setFormValue", password);
      }
    }
  }
};
</script>
